import { APP_POOL_CONFIG } from '@synergy/config';
import { Box, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolTypography } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { useNavigate } from 'react-router';

import { PhoneLink } from '../common/components/phone-link/phone-link';
import Footer from '../common/components/footer/footer';
import logoSupplier from '../common/style/pool-alpin-supplier-black.svg';

const Content = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,

    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(5),
    },
}));

const Logo = styled(Box)(() => ({
    display: 'inline-block',
    width: '100%',
    height: '130px',
    background: `url(${logoSupplier}) no-repeat center`,
    backgroundSize: 'contain',
}));

export const QuickLoginErrorPage = () => {
    const navigate = useNavigate();

    return (
        <>
            <Content>
                <Stack gap={4}>
                    <Logo />
                    <Stack
                        typography="body1"
                        justifyContent="center"
                        alignItems="center"
                        textAlign="center"
                        gap={2}
                        maxWidth={300}
                    >
                        <PoolTypography component="div" variant="h4" translationId="app.quickLoginError" />
                        <Box>
                            <PoolFormattedMessage id="app.quickLoginError.text" />
                        </Box>
                    </Stack>
                    <Box width="100%">
                        <PoolButton variant="contained" fullWidth={true} onClick={() => navigate('/login')}>
                            <FormattedMessage id="app.quickLoginError.toLogin" />
                        </PoolButton>
                    </Box>
                </Stack>
            </Content>
            <Footer>
                <Box>
                    <FormattedMessage
                        id="app.footer.questions"
                        values={{ poolConfigNameShort: APP_POOL_CONFIG['name_short'] }}
                    />{' '}
                    <PhoneLink />
                </Box>
            </Footer>
        </>
    );
};
